import { EDealType, IFiltersState, EStatus, EEntityType } from './filters';
import { IGeo } from './geo';
import { ICommercialOwnershipSchema } from '../repositories/favorites/entities/commercial_ownership/CommercialOwnershipSchema';
import { IComparisonStatusInfoSchema } from '../repositories/favorites/entities/comparison_status_info/ComparisonStatusInfoSchema';
import { IAreaPartForDesktopSchema } from '../repositories/favorites/entities/favorite_entity_for_desktop/AreaPartForDesktopSchema';
import { IClientReactionsToOfferSchema } from '../repositories/favorites/entities/favorite_entity_for_desktop/ClientReactionsToOfferSchema';
import { ICommercialInfoSchema } from '../repositories/favorites/entities/favorite_entity_for_desktop/CommercialInfoSchema';
import { ECommunicationType } from '../repositories/favorites/entities/favorite_entity_for_desktop/FavoriteEntityForDesktopSchema';

import type { IExtendedDataSchema } from '../repositories/favorites/entities/extended_data/ExtendedDataSchema';
import type { IOfferLabelSchema } from '../repositories/favorites/entities/favorite_entity_for_desktop/OfferLabelSchema';

export type TAreaPartForDesktopSchema = IAreaPartForDesktopSchema;

export enum EAccountType {
  Agency = 'agency',
  ManagementCompany = 'managementCompany',
  RentDepartment = 'rentDepartment',
  Specialist = 'specialist',
}

export interface IAgentSchema {
  accountType?: EAccountType | null;
  avatarUrl?: string | null;
  brandingName?: string | null;
  id: number;
  isCianPartner: boolean;
  isHidden: boolean;
  isMasterAgent: boolean;
  isModerationPassed: boolean;
  name: string;
  phones: string[];
  isChatEnabled: boolean;
  agentLists?: string[] | null;
  /** Форматированный тип пользователя для электронных торгов **/
  formattedPublisherType?: string;
  cianId?: number;
}

export interface ISuburbanInfoSchema {
  areaText?: string | null;
  rentTypeText?: string | null;
}

export interface IFlatInfoSchema {
  rentTypeText?: string | null;
}

export interface IJKInfo {
  id?: number;
  deadlineText?: string | null;
  floorText?: string | null;
  materialTypeText?: string | null;
}

export interface IBargainTerms {
  clientCommissionText?: string | null;
  depositText?: string | null;
  priceText?: string | null;
  utilitiesText?: string | null;
  discount?: IOfferDiscount;
}
export interface IOfferDiscount {
  /** Новая цена **/
  newPrice: string;
  /** Старая цена **/
  oldPrice: string;
  /** Процент скидки **/
  percent: string;
}

export interface IFavoriteEntity {
  agentInfo?: IAgentSchema | null;
  bargainTerms: IBargainTerms;
  categoryComplaintId?: number | null;
  commercialInfo?: ICommercialInfoSchema | null;
  dealType: EDealType;
  deleteDate?: string | null;
  description?: string | null;
  entityId: number;
  entityCianId?: number | null;
  entityType: EEntityType;
  /** Ссылка на объявление на партнерском сайте **/
  externalOfferUrl?: string;
  flatInfo?: IFlatInfoSchema | null;
  fullUrl: string;
  geo: IGeo;
  jkInfo?: IJKInfo | null;
  note?: string | null;
  phone?: string | null;
  photoFullUrl?: string | null;
  /** URL превью изображения **/
  photoPreviewUrl?: string | null;
  status?: EStatus | null;
  suburbanInfo?: ISuburbanInfoSchema | null;
  title: string;
  /** Заголовок объекта для мобильного сайта **/
  titleForMobileSite?: string | null;
  /** Является ли объявление партнерским **/
  isCianPartner?: boolean;
  isRosreestrCheckSuccess?: boolean | null;
  comparisonStatus?: IComparisonStatusInfoSchema | null;
  clientReactions: IClientReactionsToOfferSchema;
  /** Данные о собственнике коммерческой недвижимости **/
  commercialOwnership?: ICommercialOwnershipSchema | null;
  communicationType?: ECommunicationType | null;
  /** Ссылка на платформу электронных торгов **/
  tradingLink?: string;
  /** Дополнительные данные для объявлений посутки **/
  dailyrent?: IExtendedDataSchema;
  labels: IOfferLabelSchema[];
  isBookedFromDeveloper?: boolean;
  isEarlyAccessEnabled?: boolean;
}

export enum EGetFavoriteEntitiesStatus {
  Initial = 'initial',
  Loading = 'loading',
  NextPageLoading = 'next_page_loading',
  Succeed = 'succeed',
  Failed = 'failed',
}

export interface IRemoveFavorite {
  entityIds: number[] | null;
}

export interface IResultsState {
  status: EGetFavoriteEntitiesStatus;
  filters: IFiltersState;
  favoriteEntities: IFavoriteEntity[];
  hasMore: boolean;
  restoringFavoriteEntities: number[];
  removeFavorite: IRemoveFavorite;
  editingNotes: IEditingNotes;
  deletingNotes: number[];
  total: number;
  clientCommentToFolder?: string | null;
}

export interface ISelfEmployed {
  isNeedSelfEmployedConfirmation: boolean;
}

export interface IEditingNotes {
  [key: number]: INoteFetchingInfo;
}

export interface INoteFetchingInfo {
  isFetching: boolean;
  isFetchSuccess: boolean;
  isFetchFail: boolean;
}

export enum EEntityTypeOld {
  OfferResidental = 'offerResidental',
  OfferSuburban = 'offerSuburban',
  OfferCommercial = 'offerCommercial',
  Newbuilding = 'newbuilding',
}

export interface IBusinessCenterInfo {
  name: string;
  fullUrl: string;
}
